const CommentBubbleIcon = ({ size = 11 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        d="M7 2c2.8 0 5 1.8 5 4.1 0 2.3-2.2 4.1-5 4.1-.6 0-1.2-.08-1.7-.24L2.6 11.4l.5-2A3.8 3.8 0 012 6.1C2 3.8 4.2 2 7 2z"
        fill="currentColor"
      />
      <circle cx="5.2" cy="6.1" r=".72" fill="#fff" />
      <circle cx="7" cy="6.1" r=".72" fill="#fff" />
      <circle cx="8.8" cy="6.1" r=".72" fill="#fff" />
    </svg>
  );
};

export default CommentBubbleIcon;
